<form #frmFileUploadImage
      id="frmFileUploadImage">
   <dx-file-uploader #fileUploadImage
                     class="file-uploader"
                     [multiple]="true"
                     (onValueChanged)="addImage($event)"
                     [uploadMethod]="'POST'"
                     [showFileList]="false"
                     uploadUrl=""
                     uploadButtonText="Carica"
                     selectButtonText="Sfoglia Immagini Oppure Trascina Qui"
                     labelText="Oppure trascina il file qui"
                     accept="image/*"
                     uploadMode="useForm"
   >
   </dx-file-uploader>
</form>

<div class="p-5">
   <mat-grid-list cols="6" rowHeight="2:1">
      <mat-grid-tile *ngFor="let image of images; let i = index">
         <button class="absolute top-0 right-0 bg-amber-500 w-5 rounded text-center" (click)="cancelImage(i)">
            <i class="fa fa-close"></i>
         </button>
         <img [src]="image.base" alt="">
      </mat-grid-tile>
   </mat-grid-list>
</div>
